export default __webpack_public_path__ + "static/media/About.9c91cff7.jpeg";